import { SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import BroadsheetLink from "@/src/components/common/broadsheet/link";
import {
  actionSx,
  ActionVariant,
} from "@/src/components/common/broadsheet/tokens";

export default function ActionButton({
  children,
  href,
  variant = "solid",
  external = false,
  size = "medium",
  sx,
}: {
  children: ReactNode;
  href: string;
  variant?: ActionVariant;
  external?: boolean;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
}) {
  return (
    <BroadsheetLink
      href={href}
      external={external}
      sx={[actionSx(variant, size), ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {children}
    </BroadsheetLink>
  );
}
